import { Col as AntCol, ColProps as AntColProps } from 'antd';

interface ColProps extends AntColProps {}

const Col: React.FC<ColProps> = (props) => <AntCol {...props} />;
export default Col;
